module.exports = __webpack_public_path__ + "static/media/doble-burger.f2c4647d.jpg";